import employersApplicationsList from "./employersApplicationsList";
import employersLoansList from "./employersLoansList";

export default {
  applist: employersApplicationsList,
  loanlist: employersLoansList,
};
